import React from 'react';
import styles from './ScrollMenu.module.css';

/*
 * Scrolling menu item
 */
const MenuItem = ({ itemName, active, setActiveItem, targetPosition, setScrollTarget, target, labelMap = {} }) => {

  // handles click on the menu item, scrolls to the corresponding target section
  const handleClick = event => {
    event.preventDefault();

    const targetNode = document.querySelector(`#${target}`);
    const startingPos = targetNode.scrollTop;

    let y = startingPos;
    const scroll = setInterval(function () {
      targetNode.scroll(0, y);
      if (Math.abs(y - targetPosition) <= 10) {
        targetNode.scroll(0, targetPosition + 1)
        clearInterval(scroll);
      }
      y = y + (targetPosition - startingPos > 0 ? 10 : -10);
    }, 2);

    setScrollTarget(itemName);
    setActiveItem(itemName);
  };

  const displayName = labelMap[itemName.split('_').join(' ')] || itemName.split('_').join(' ');

  return (
    <>
      <div className={active ? styles.active : null}>
        <a href={`#${itemName}`}
          onClick={handleClick}
          className={active ? styles.active : null}
          aria-label={`Scroll to ${itemName}`}>
          {displayName}
        </a>
      </div>
    </>
  );
};

export default MenuItem;
